import { Settings2Icon, Unplug } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { HOME, getUserProfil, resetStorage, userToken } from "../Utils/Utils";
import LOGO from "../assets/images/mtn.png";
import { SideBarMenu } from "../components/Menu/SideBarMenu";
import { logout } from "../services/service";
export const Layout = () => {
  const navigate = useNavigate();
  // const menu = getUserMenu()
  const [listeMenuComplet, setListeMenuComplet] = useState([]);
  const [vericalMenu, setVerticalMenu] = useState([]);
  const [active, setActive] = useState(null);
  const location = useLocation();
  const user = getUserProfil();

  useEffect(() => {
    const listeMenuCompletEnLocal = localStorage.getItem("menu")
      ? JSON.parse(localStorage.getItem("menu"))
      : [];
    const selectedMenuParent = localStorage.getItem("selectedMenuParent")
      ? JSON.parse(localStorage.getItem("selectedMenuParent"))
      : [];
    const accessToken = userToken();

    setListeMenuComplet(
      listeMenuCompletEnLocal.sort(function (a, b) {
        return a?.menu?.numeroOrdre - b?.menu?.numeroOrdre;
      })
    );
    if (selectedMenuParent.length !== 0) {
      setVerticalMenu(selectedMenuParent?.sousMenus);
      setActive(selectedMenuParent?.menu?.numeroOrdre);
    } else {
      setVerticalMenu(
        listeMenuCompletEnLocal[0]?.sousMenus?.sort(function (a, b) {
          return a?.menu?.numeroOrdre - b?.menu?.numeroOrdre;
        })
      );
      setActive(listeMenuCompletEnLocal[0]?.menu?.numeroOrdre);
    }

    if (!accessToken) {
      navigate(`${HOME}/login`);
    }

    if (listeMenuCompletEnLocal?.length === 0) {
      navigate("/pas-autorise");
    }

    let link = [];
    listeMenuCompletEnLocal?.map((menu) => {
      return menu?.sousMenus?.filter(
        (e) => e.sousMenu.route === "/" + location.pathname.split("/")[2]
      ).length === 0
        ? []
        : (link = menu?.sousMenus?.filter(
            (e) => e.sousMenu.route === "/" + location.pathname.split("/")[2]
          ));
    });

    if (link?.length === 0) {
      if (location.pathname !== HOME && listeMenuCompletEnLocal) {
        if (location.pathname !== HOME + "/profil") {
          navigate("/pas-autorise");
        }
      } else {
        navigate(`${HOME}/login`);
      }
    } else {
      localStorage.setItem("action", JSON.stringify(link[0].actions));
    }

    console.log(link);
  }, [navigate, location]);

  return (
    <div className="grid min-h-screen w-full lg:grid-cols-[280px_1fr]">
      <SideBarMenu menu={vericalMenu} />
      <div className="flex flex-col px-1">
        <header className="rounded-lg hidden lg:flex font-mtn w-full relative sticky top-2 h-11  items-center bg-main/70 backdrop-blur-lg px-2 z-50">
          <div className="flex gap-4 w-full">
            {listeMenuComplet
              .sort(function (a, b) {
                return a?.menu?.numeroOrdre - b?.menu?.numeroOrdre;
              })
              .map((item, index) => (
                <NavLink
                  key={index}
                  to={HOME + item?.sousMenus[0]?.sousMenu?.route}
                  onClick={() => {
                    localStorage.setItem(
                      "groupe",
                      JSON.stringify(item?.sousMenus)
                    );
                    localStorage.setItem(
                      "selectedMenuParent",
                      JSON.stringify(item)
                    );
                    setActive(item?.menu?.numeroOrdre);
                    setVerticalMenu(item?.sousMenus);
                  }}
                  className={`text-xs font-medium py-2 px-2 ${
                    active === item?.menu?.numeroOrdre
                      ? "bg-black text-white rounded-lg"
                      : ""
                  }`}
                >
                  {item?.menu?.description}
                </NavLink>
              ))}

            <div className="dropdown dropdown-end ml-auto">
              <div
                tabIndex={0}
                className="cursor-pointer bg-white/50 px-3 py-1 rounded-full flex flex-row gap-2 items-center"
              >
                <img src={LOGO} alt="" className="w-6 rounded-2xl" />
                <h2 className="text-xs font-normal text-gray-700">
                  {user?.nomPrenoms} (
                  {user?.roles[0].replace(/ROLE_/g, " ").replace(/_/g, " ")})
                </h2>
              </div>{" "}
              <ul
                tabIndex={0}
                className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
              >
                <li>
                  <Link to={HOME + "/profil"}>
                    <Settings2Icon size={16} />
                    Modifier mes accès
                  </Link>
                </li>
                <li>
                  <span
                    onClick={() => {
                      logout(user?.username).then(() => {
                        resetStorage();
                        navigate("login");
                      });
                    }}
                  >
                    <Unplug size={16} />
                    Deconnexion
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </header>
        <main className="flex flex-1 flex-col p-3 lg:pt-10 pt-20">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
